"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uses = exports.ButtonOpaqueness = exports.Design = exports.Material = exports.ButtonType = exports.SellingUnit = void 0;
var SellingUnit;
(function (SellingUnit) {
    SellingUnit["Individual"] = "Individual";
    SellingUnit["Pack"] = "Pack";
})(SellingUnit = exports.SellingUnit || (exports.SellingUnit = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["Sew-on Snap"] = "Sew-on Snap";
    ButtonType["Spring Snap"] = "Spring Snap";
    ButtonType["Grommet"] = "Grommet";
    ButtonType["2 Hole"] = "2 Hole";
    ButtonType["4 Hole"] = "4 Hole";
    ButtonType["Toggle"] = "Toggle";
    ButtonType["Shank"] = "Shank";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
var Material;
(function (Material) {
    Material["Metal"] = "Metal";
    Material["Plastic"] = "Plastic";
    Material["Wood"] = "Wood";
    Material["Shell"] = "Shell";
    Material["Paper"] = "Paper";
    Material["Leather Covered"] = "Leather Covered";
    Material["Fabric Covered"] = "Fabric Covered";
    Material["Brass"] = "Brass";
})(Material = exports.Material || (exports.Material = {}));
var Design;
(function (Design) {
    Design["Engraved"] = "Engraved";
    Design["Floral"] = "Floral";
    Design["Polka Dots"] = "Polka Dots";
    Design["Stripes"] = "Stripes";
    Design["Paisley"] = "Paisley";
    Design["Abstract"] = "Abstract";
    Design["Sparkles"] = "Sparkles";
    Design["Marbled"] = "Marbled";
    Design["Embossed"] = "Embossed";
})(Design = exports.Design || (exports.Design = {}));
var ButtonOpaqueness;
(function (ButtonOpaqueness) {
    ButtonOpaqueness["Translucent"] = "Translucent";
    ButtonOpaqueness["Transparent"] = "Transparent";
})(ButtonOpaqueness = exports.ButtonOpaqueness || (exports.ButtonOpaqueness = {}));
var Uses;
(function (Uses) {
    Uses["Home Decor"] = "Home Decor";
    Uses["Accessories"] = "Accessories";
    Uses["Apparel"] = "Apparel";
})(Uses = exports.Uses || (exports.Uses = {}));
//# sourceMappingURL=buttonProductAttributes.js.map